module.exports = __webpack_public_path__ + "static/media/instagram.59ba971c.svg";